var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import { TouchableOpacity, View } from 'react-native';
const StyledOptionsWrapper = styled((_a) => {
    var { theme, customStyle, touchable } = _a, rest = __rest(_a, ["theme", "customStyle", "touchable"]);
    return touchable ? <TouchableOpacity {...rest}/> : <View {...rest}/>;
}) `
  flex-direction: column;
  background-color: transparent;
  border-top-width: 0;
  z-index: 1;
  ${props => props.customStyle}
`;
StyledOptionsWrapper.defaultProps = {
    hovered: false,
    touchable: false,
};
export default StyledOptionsWrapper;
